import { ReactElement, useEffect, useRef } from 'react';
import { ToastType, useTosterStore } from '@store/toster';

export const Toster = (): ReactElement => {
	const { message, setToaster, className, toasterTime = 3000 } = useTosterStore();
	const toastRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const toast = toastRef.current;
		if (!toast) return;

		toast.classList.remove('hidden');
		if ('showPopover' in toast) {
			toast.showPopover();
		}

		const toastTimeout = setTimeout(() => {
			toast.classList.add('hidden');
			if ('hidePopover' in toast) {
				toast.hidePopover();
			}
			setToaster(false);
		}, toasterTime);

		return (): void => {
			clearTimeout(toastTimeout);
			if ('hidePopover' in toast && toast.matches(':popover-open')) {
				toast.hidePopover();
			}
		};
	}, [setToaster, toasterTime]);

	return (
		<div ref={toastRef} id="toast" popover="manual" className={`toast-message ${className}`}>
			<div className="toast-content-wrapper">
				<div className="toast-icon">
					<span className={`icon ${ToastType.error === className ? 'icon-alert-triangle' : 'icon-thumbs-up'}`} />
				</div>
				<div className="toast-content">
					<span dangerouslySetInnerHTML={{ __html: message }}></span>
				</div>
				<button aria-label="close toast" type="button" className="cross-icon" onClick={() => setToaster(false)}>
					<span className="icon-x-circle" />
				</button>
			</div>
		</div>
	);
};
